import { useTranslation } from 'react-i18next';
import { ExclamationTriangleIcon } from '@c2fo/liquidity/icons';

const ReadOnlyBanner = ({ isImpersonation }: { isImpersonation: boolean }) => {
  const { t } = useTranslation();
  const message = isImpersonation ? t('core.readOnlyBannerImpersonation') : t('core.readOnlyBanner');

  return (
    <div className="w-full bg-warning-400 text-text-primary">
      <div className="flex h-10 items-center gap-2 px-4">
        <div>
          <ExclamationTriangleIcon />
        </div>
        <div aria-description={message} className="min-w-0 truncate text-sm" title={message}>
          {message}
        </div>
      </div>
    </div>
  );
};

export default ReadOnlyBanner;
